module.exports = __webpack_public_path__ + "img/bg3.24f62dd1.jpg";